import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=10ee9961"
import script from "./badge.vue?vue&type=script&lang=js"
export * from "./badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports